<template>
  <div class="c-payment-form">
    <form
      id="payment-form"
      class="c-form c-form--contact c-form--payment"
      v-bind:class="{'c-form--loading': orderLoading}"
    >
      <div class="c-spinner__container" v-bind:class="{'c-spinner--visible': orderLoading}">
        <div class="c-spinner c-spinner__sphere"></div>
      </div>
      <div class="c-field__section">
        <div class="c-checkout">
          <div class="c-field" v-bind:class="{'c-field--valid': nameValid }">
            <label class="c-field__label">Name</label>
            <div class="control has-icons-left has-icons-right">
              <input class="c-field__input" type="text" placeholder="First and Last" v-model="name" />
            </div>
          </div>
          <div class="c-field" v-bind:class="{'c-field--valid': emailValid }">
            <label class="c-field__label">Email</label>
            <div class="control has-icons-left has-icons-right">
              <input class="c-field__input" type="text" placeholder="Email address" v-model="email" />
            </div>
          </div>
          <div class="c-field c-field--checkbox">
            <input
              class="c-field__input--checkbox"
              type="checkbox"
              name="NewsletterSignup"
              id="newsletterSignup"
              v-model="newsletterSignup"
            />
            <label
              for="newsletterSignup"
              class="c-field__label c-field__label--checkbox"
            >Sign up to our newsletter</label>
            <!-- maybe make a little Thanks! Have 5% off this order :) -->
          </div>
          <section v-show="nameValid && emailValid">
            <div class="c-field" v-bind:class="{'c-field--valid': streetValid }">
              <label class="c-field__label">Address</label>
              <input
                id="address"
                class="c-field__input"
                type="text"
                v-model="address.street"
                placeholder
              />
            </div>
            <div class="c-field">
              <label class="c-field__label">
                Address
                <span class="c-form__option">(optional)</span>
              </label>
              <input
                class="c-field__input"
                type="text"
                v-model="address.street2"
                placeholder="Apartment, suite, ect."
              />
            </div>
            <div class="c-field" v-bind:class="{'c-field--valid': cityValid }">
              <label class="c-field__label">City</label>
              <input
                id="locality"
                class="c-field__input"
                type="text"
                v-model="address.city"
                placeholder
              />
            </div>
            <div class="c-field__section">
              <div class="c-field" v-bind:class="{'c-field--valid': stateValid }">
                <label class="c-field__label">Region</label>
                <input
                  id="administrative_area_level_1"
                  class="c-field__input"
                  type="text"
                  v-model="address.state"
                  placeholder
                />
              </div>
              <div class="c-field" v-bind:class="{'c-field--valid': zipValid }">
                <label class="c-field__label">Post Code</label>
                <input
                  id="postal_code"
                  class="c-field__input"
                  type="text"
                  v-model="address.zip"
                  placeholder
                />
              </div>
            </div>
            <div class="c-field__section">
              <div class="c-field" v-bind:class="{'c-field--valid': countryValid }">
                <label class="c-field__label">Country</label>
                <input
                  id="country"
                  class="c-field__input"
                  type="text"
                  v-model="address.country"
                  placeholder
                />
              </div>
              <div class="c-field">
                <label class="c-field__label">
                  Company
                  <span class="c-form__option">(optional)</span>
                </label>
                <input class="c-field__input" type="text" v-model="address.company" placeholder />
              </div>
            </div>
            <div class="c-field c-field--checkbox">
              <input
                class="c-field__input--checkbox"
                type="checkbox"
                name="billingAndShipping"
                id="billingAndShipping"
                v-model="billingAndShipping"
              />
              <label
                for="billingAndShipping"
                class="c-field__label c-field__label--checkbox"
              >Deliver to this address</label>
            </div>
          </section>
          <section v-show="!billingAndShipping">
            <div class="c-field" v-bind:class="{'c-field--valid': shippingCountryValid }">
              <label class="c-field__label">Shipping Country</label>
              <input class="c-field__input" type="text" v-model="address2.country" placeholder />
            </div>
            <div class="c-field">
              <label class="c-field__label">
                Shipping Company
                <span class="c-form__option">(optional)</span>
              </label>
              <input class="c-field__input" type="text" v-model="address2.company" placeholder />
            </div>
            <div class="c-field" v-bind:class="{'c-field--valid': shippingStreetValid }">
              <label class="c-field__label">Shipping Address</label>
              <input class="c-field__input" type="text" v-model="address2.street" placeholder />
            </div>
            <div class="c-field">
              <label class="c-field__label">
                Shipping Address
                <span class="c-form__option">(optional)</span>
              </label>
              <input
                class="c-field__input"
                type="text"
                v-model="address2.street2"
                placeholder="Apartment, suite, ect."
              />
            </div>
            <div class="c-field" v-bind:class="{'c-field--valid': shippingCityValid }">
              <label class="c-field__label">Shipping City</label>
              <input class="c-field__input" type="text" v-model="address2.city" placeholder />
            </div>
            <div class="c-field__section">
              <div class="c-field" v-bind:class="{'c-field--valid': shippingStateValid }">
                <label class="c-field__label">Shipping Region</label>
                <input class="c-field__input" type="text" v-model="address2.state" placeholder />
              </div>
              <div class="c-field" v-bind:class="{'c-field--valid': shippingZipValid }">
                <label class="c-field__label c-field__label--smaller">Shipping Post Code</label>
                <input class="c-field__input" type="text" v-model="address2.zip" placeholder />
              </div>
            </div>
          </section>
          <a
            href
            class="c-btn c-btn__link c-btn__link--back"
            v-on:click="closeOrder($event)"
          >Go back</a>
        </div>
        <div class="c-checkout c-checkout--right">
          <div class="c-field c-field--no-flex c-field--textarea">
            <label class="c-field__label">
              Order Note
              <span class="c-form__option">(optional)</span>
            </label>
            <textarea
              class="c-field__input c-field__input--textarea"
              rows="3"
              placeholder
              v-model="engravingText"
            ></textarea>
          </div>

          <div class="c-checkout__cart">
            <li v-for="(ring, index) in cart" :key="ring.id" class="c-cart__item">
              <img
                class="c-cart__image"
                v-bind:src="ring.ring.variations[ring.ring.variationIndex].images[0].url"
              />
              <div class="c-cart__item-details">
                <p
                  class="c-cart__detail"
                >Metal: {{ ring.ring.variations[ring.ring.variationIndex].variation_name }}</p>
                <span class="c-cart__detail">Size: {{ ring.selectedSize.text }}</span>
              </div>

              <div class="c-cart__item-details c-cart__item-details--al-m">
                <p
                  class="c-cart__price"
                >{{ ring.ring.variations[ring.ring.variationIndex].price[$store.state.currency].formatted }}</p>
              </div>
            </li>
            <div class="c-cart__totals">
              <div class="c-cart__subTotal">
                <span class="c-cart__subTotal-total">TOTAL</span>
                <span class="c-cart__subTotal-currency">({{$store.state.currency}})</span>
                <span class="c-cart__subTotal-price">
                  <span v-show="$store.state.currency != 'EUR' && $store.state.currency != 'GBP'">$</span>
                  <span v-show="$store.state.currency == 'EUR'">€</span>
                  <span v-show="$store.state.currency == 'GBP'">£</span>
                  {{total}}.00
                </span>
              </div>
            </div>
            <p class="c-checkout__text">Shipping is free on all orders</p>
            <span v-show="!payByBankDeposit" class="c-checkout__cards">
              <img alt="visa" src="../assets/paymentIcons/visa.png" />
              <img alt="mastercard" src="../assets/paymentIcons/mastercard.png" />
              <img alt="americanexpress" src="../assets/paymentIcons/americanexpress.png" />
            </span>
          </div>

          <div
            class="c-field c-field--checkbox"
            v-bind:class="{'c-field--checkbox--small':payByBankDeposit}"
            v-show="nameValid && emailValid && ((billingAndShipping && countryValid && streetValid && cityValid && stateValid && zipValid) || (countryValid && streetValid && cityValid && stateValid && zipValid && shippingCountryValid && shippingStreetValid && shippingCityValid && shippingStateValid && shippingZipValid))"
          >
            <input
              class="c-field__input--checkbox"
              type="checkbox"
              name="payByDeposit"
              id="payByDeposit"
              v-model="payByBankDeposit"
            />
            <label
              for="payByDeposit"
              class="c-field__label c-field__label--checkbox"
            >Pay by bank deposit</label>
          </div>
          <div
            class="c-checkout__deposit"
            v-if="payByBankDeposit && nameValid && emailValid && ((billingAndShipping && countryValid && streetValid && cityValid && stateValid && zipValid) || (countryValid && streetValid && cityValid && stateValid && zipValid && shippingCountryValid && shippingStreetValid && shippingCityValid && shippingStateValid && shippingZipValid))"
          >
            Please make your payment directly into our bank account, use your OrderID as Payment Reference.
            <br />Artful Dodgers Ltd
            <br />
            06-0601-0777165-01
            &nbsp;
            Order: {{orderNumber}}
          </div>
          <div
            class="c-field c-field--pay"
            v-show="!payByBankDeposit && nameValid && emailValid && ((billingAndShipping && countryValid && streetValid && cityValid && stateValid && zipValid) || (countryValid && streetValid && cityValid && stateValid && zipValid && shippingCountryValid && shippingStreetValid && shippingCityValid && shippingStateValid && shippingZipValid))"
          >
            <label for="card-element" class="c-field__label">Credit or debit card</label>
            <div id="card-element" class="c-field--card">
              <!-- A Stripe Element will be inserted here. -->
            </div>

            <!-- Used to display Element errors. -->
            <div class="c-field__error c-field__error--payment" id="card-errors" role="alert"></div>
            <span
              v-show="paymentError != ''"
              class="c-field__error c-field__error--payment"
            >{{ paymentError }}</span>
            <button class="c-form__submit c-btn--block">Complete Order</button>
          </div>
          <button
            v-on:click="bankDeposit($event)"
            class="c-form__submit c-btn--block"
            v-show="payByBankDeposit && nameValid && emailValid && ((billingAndShipping && countryValid && streetValid && cityValid && stateValid && zipValid) || (countryValid && streetValid && cityValid && stateValid && zipValid && shippingCountryValid && shippingStreetValid && shippingCityValid && shippingStateValid && shippingZipValid))"
          >Complete Order</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
var placeSearch, autocomplete;

var componentForm = {
  street_number: "short_name",
  route: "long_name",
  locality: "long_name",
  administrative_area_level_1: "short_name",
  country: "long_name",
  postal_code: "short_name",
};

// window.initAutocomplete = function () {
//   console.log(document.getElementById("address"));
//   autocomplete = new google.maps.places.Autocomplete(
//     document.getElementById("address"),
//     { types: ["geocode"] }
//   );

//   autocomplete.setFields(["address_component"]);
//   autocomplete.addListener("place_changed", fillInAddress);
// };

//need to bring into VUE to set v-models
// function fillInAddress() {
//   // Get the place details from the autocomplete object.
//   var place = autocomplete.getPlace();

//   // Get each component of the address from the place details,
//   // and then fill-in the corresponding field on the form.
//   for (var i = 0; i < place.address_components.length; i++) {
//     if (i == 0) {
//       // var addressType = place.address_components[i].types[0];
//       // if (componentForm[addressType]) {
//       //     var val = place.address_components[i][componentForm[addressType]];
//       //     document.getElementById(addressType).value = val;
//       // }
//       i++;
//     } else {
//       var addressType = place.address_components[i].types[0];
//       if (componentForm[addressType]) {
//         console.log("address type ", addressType);
//         var val = place.address_components[i][componentForm[addressType]];
//         console.log("val ", val);
//         document.getElementById(addressType).value = val;
//       }
//     }
//   }
// }

// Bias the autocomplete object to the user's geographical location,
// as supplied by the browser's 'navigator.geolocation' object.
function geolocate() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      var geolocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      var circle = new google.maps.Circle({
        center: geolocation,
        radius: position.coords.accuracy,
      });
      autocomplete.setBounds(circle.getBounds());
    });
  }
}

//TODO maybe change region and postcode to state + zip with US customers
import store from "../main.js";
import { mapGetters } from "vuex";

export default {
  name: "Order",
  data: function () {
    return {
      ring: {},

      stripeKey: "pk_live_a8UpAVLUZCiMu5IDKp5ytMvQ",

      name: "",
      email: "",
      engravingText: "",
      paymentError: "",
      address: {
        country: "",
        street: "",
        street2: "",
        city: "",
        state: "",
        zip: "",
      },
      address2: {
        country: "",
        street: "",
        street2: "",
        city: "",
        state: "",
        zip: "",
      },

      card: {
        number: "",
        cvc: "",
        exp_month: "",
        exp_year: "",
      },

      payByBankDeposit: false,

      // validation
      cardNumberError: null,
      cardCvcError: null,
      cardMonthError: null,
      cardYearError: null,
      cardCheckSending: false,
      cardCheckError: false,
      cardCheckErrorMessage: "",
      errorIfSo: "",
      billingAndShipping: true,
      newsletterSignup: true,

      nameValid: false,
      emailValid: false,

      countryValid: false,
      streetValid: false,
      cityValid: false,
      stateValid: false,
      zipValid: false,
      shippingCountryValid: false,
      shippingStreetValid: false,
      shippingCityValid: false,
      shippingStateValid: false,
      shippingZipValid: false,
      total: 0,
      orderNumber: 0,
      orderLoading: false,
    };
  },
  props: ["cart"],
  created: function () {
    this.ring = this.$store.state.ringChoice;
  },
  watch: {
    name: function (newVal, oldVal) {
      if (newVal.length > 2) {
        this.nameValid = true;
      } else {
        this.nameValid = false;
      }
      self = this;
      setTimeout(function () {
        self.$parent.checkHeight($("#payment-form").height());
      }, 50);
    },
    email: function (newVal, oldVal) {
      if (this.validEmail(newVal)) {
        this.emailValid = true;
      } else {
        this.emailValid = false;
      }
      self = this;
      setTimeout(function () {
        self.$parent.checkHeight($("#payment-form").height());
      }, 50);
    },
    billingAndShipping: function () {
      self = this;

      setTimeout(function () {
        self.$parent.checkHeight($("#payment-form").height());
      });
    },
    address: {
      handler(val) {
        var self = this;

        if (val.country.length > 3) {
          this.countryValid = true;
        } else {
          this.countryValid = false;
        }

        if (val.city.length > 3) {
          this.cityValid = true;
        } else {
          this.cityValid = false;
        }

        if (val.street.length > 3) {
          this.streetValid = true;
        } else {
          this.streetValid = false;
        }

        if (val.state.length > 3) {
          this.stateValid = true;
        } else {
          this.stateValid = false;
        }

        if (val.zip.length > 3) {
          this.zipValid = true;
        } else {
          this.zipValid = false;
        }

        self.$parent.checkHeight($("#payment-form").height());
      },
      deep: true,
    },
    address2: {
      handler(val) {
        var self = this;

        if (val.country.length > 3) {
          this.shippingCountryValid = true;
        } else {
          this.shippingCountryValid = false;
        }

        if (val.city.length > 3) {
          this.shippingCityValid = true;
        } else {
          this.shippingCityValid = false;
        }

        if (val.street.length > 3) {
          this.shippingStreetValid = true;
        } else {
          this.shippingStreetValid = false;
        }

        if (val.state.length > 3) {
          this.shippingStateValid = true;
        } else {
          this.shippingStateValid = false;
        }

        if (val.zip.length > 3) {
          this.shippingZipValid = true;
        } else {
          this.shippingZipValid = false;
        }
      },
      deep: true,
    },
    cart: function (newVal, oldVal) {
      var self = this;

      self.total = 0;
      self.cart.forEach(function (item) {
        self.total +=
          item.ring.variations[item.ring.variationIndex].price[0].amount;
      });
      self.total = self.total / 100;
    },
    immediate: true,
  },
  methods: {
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    closeOrder: function (event) {
      event.preventDefault();
      self.$parent.calcCartHeight(true);
      this.$parent.closeOrder();
    },
    processOrder: function () {
      //SEND EMAIL WAIT TILL COMPLETE - Specialy for bank deposit TODO
      var details = {
        name: this.name,
        email: this.email,
        address: this.address,
        address2: this.address2,
        engravingText: this.engravingText,
        billingAndShipping: this.billingAndShipping,
        orderNumber: this.orderNumber,
        payByBankDeposit: this.payByBankDeposit,
      };
      this.$store.commit("updateDetails", details);
      this.$parent.completeOrder();
      this.$router.push("/order-complete/" + this.orderNumber);
    },
    bankDeposit: function (event) {
      var self = this;
      event.preventDefault();
      const url =
        "https://5nvshjds5f.execute-api.us-west-2.amazonaws.com/dev/email/send";
      const payload = {
        name: "BANK DEPOSIT",
        email: this.email,
        content: JSON.stringify({
          name: this.name,
          email: this.email,
          address: this.address,
          address2: this.address2,
          engravingText: this.engravingText,
          billingAndShipping: this.billingAndShipping,
          orderNumber: this.orderNumber,
          payByBankDeposit: this.payByBankDeposit,
        }),
      };
      self.postBankDeposit(url, payload, function (err, res) {
        if (err) {
          return error(err);
        }
        self.successBankDeposit();
      });
    },
    postBankDeposit: function (url, body, callback) {
      var req = new XMLHttpRequest();
      req.open("POST", url, true);
      req.setRequestHeader("Content-Type", "application/json");
      req.addEventListener("load", function () {
        if (req.status < 400) {
          callback(null, JSON.parse(req.responseText));
        } else {
          callback(new Error("Request failed: " + req.statusText));
        }
      });
      req.send(JSON.stringify(body));
    },
    successBankDeposit: function () {
      console.log("success");
      this.processOrder();
    },
    sortMaps: function () {},
    loadStripe: function () {
      var self = this;
      var stripeScript = document.createElement("script");

      stripeScript.onload = function () {
        self.$nextTick(function () {
          var stripe = Stripe("pk_live_a8UpAVLUZCiMu5IDKp5ytMvQ");
          var elements = stripe.elements();

          var style = {
            base: {
              // Add your base input styles here. For example:
              fontSize: "16px",
              color: "#32325d",
            },
          };

          // Create an instance of the card Element.
          var card = elements.create("card", { style: style });
          card.mount("#card-element");
          card.addEventListener("change", function (event) {
            var displayError = document.getElementById("card-errors");
            if (event.error) {
              displayError.textContent = event.error.message;
            } else {
              displayError.textContent = "";
            }
          });

          var form = document.getElementById("payment-form");
          form.addEventListener("submit", function (event) {
            event.preventDefault();

            self.orderLoading = true;

            var details = {
              name: self.name,
              address_line1: self.address.street,
              address_line2: self.address.street2,
              address_city: self.address.city,
              address_state: self.address.state,
              address_zip: self.address.zip,
              address_country: self.address.country,
            };

            stripe.createToken(card, details).then(function (result) {
              if (result.error) {
                // Inform the customer that there was an error.
                var errorElement = document.getElementById("card-errors");
                errorElement.textContent = result.error.message;
                self.orderLoading = false;
              } else {
                var token = result.token;

                const url =
                  "https://3rfnpupkmh.execute-api.us-east-1.amazonaws.com/dev/charges";
                function post(url, body, callback) {
                  var req = new XMLHttpRequest();
                  req.open("POST", url, true);
                  req.setRequestHeader("Content-Type", "application/json");
                  req.addEventListener("load", function () {
                    if (req.status < 400) {
                      callback(null, JSON.parse(req.responseText));
                      self.orderLoading = false;
                    } else {
                      callback(JSON.parse(req.responseText));
                      self.orderLoading = false;
                    }
                  });
                  req.send(JSON.stringify(body));
                }
                function success() {
                  self.processOrder();
                }
                function error(err) {}
                var collectedIds = [];

                self.metadata = {
                  orderDetails: details,
                  items: [],
                };

                self.$store.state.cart.forEach(function (e) {
                  collectedIds.push(
                    e.ring.variations[e.ring.variationIndex].guid
                  );
                  var item = {
                    itemName: e.ring.name,
                    itemSKU: e.ring.sku,
                    itemDescription: "Signet ring",
                    itemSize: e.selectedSize.text,
                    itemPrice:
                      e.ring.variations[e.ring.variationIndex].price[
                        self.$store.state.currency
                      ].formatted,
                    itemMetal:
                      e.ring.variations[e.ring.variationIndex].variation_name,
                    itemImage:
                      e.ring.variations[e.ring.variationIndex].images[0].url,
                  };
                  self.metadata.items.push(item);
                });

                details.orderNumber = self.orderNumber;
                var dateTime = new Date();
                details.orderDate = dateTime.toLocaleDateString("en-US");

                details.total =
                  self.$store.state.currency + " $" + self.total + ".00";

                var shippingAddress = self.billingAndShipping
                  ? self.address
                  : self.address2;

                const payload = {
                  token,
                  charge: {
                    email: self.email,
                    details: details,
                    items: self.metadata.items,
                    currency: self.$store.state.currency,
                    ids: collectedIds,
                    address: shippingAddress,
                    notes: self.engravingText,
                  },
                };
                post(url, payload, function (err, res) {
                  if (err) {
                    console.log("error", err.error);
                    self.paymentError = err.error;
                    return error(err);
                  }
                  self.successBankDeposit();
                });
              }
            });
          });
        });
      };
      stripeScript.setAttribute("src", "https://js.stripe.com/v3/");
      document.head.appendChild(stripeScript);
    },
  },
  mounted: function () {
    var self = this;

    self.loadStripe();

    if (window.matchMedia("(max-width:765px)").matches) {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        500
      );
    }

    // let placesScript = document.createElement("script");
    // placesScript.setAttribute(
    //   "src",
    //   "https://maps.googleapis.com/maps/api/js?key=AIzaSyBI__lpB-Ne0EFz-7ovnHCiQ4jR1bGGHRQ&libraries=places&callback=initAutocomplete"
    // );
    // document.body.appendChild(placesScript);

    self.total = 0;
    self.cart.forEach(function (item) {
      self.total +=
        item.ring.variations[item.ring.variationIndex].price[
          self.$store.state.currency
        ].amount;
    });
    self.total = self.total / 100;

    self.orderNumber = Math.floor(1000 + Math.random() * 9000);
  },
};
</script>

<style scoped lang="scss">
.temp {
  background: red;
  padding: 12px;
  margin-bottom: 12px;
  color: white;

  h2 {
    font-size: 18px;
    font-weight: 600;
  }
}
</style>


// WEBPACK FOOTER //
// Order.vue?1ea78a6a